import { useLocation } from 'react-router-dom';

import ROUTE_NAMES from 'setup/Routing/routeNames';
import useTeamPath from 'hooks/useTeamPath';

// Routes reached through "Back to All Teams". They have no /t/:teamKey prefix,
// but the last-viewed team is still loaded in the Sentinel team context.
const TEAMLESS_ROUTES = [
  ROUTE_NAMES.teams,
  ROUTE_NAMES.admin.management,
  ROUTE_NAMES.superadmin.oem_onboard,
  ROUTE_NAMES.superadmin.reports,
];

/**
 * True on the All Teams pages (Teams, Management, OemSegments Onboarding,
 * Reports) when the URL carries no team key. Callers use it to ignore the
 * last-viewed team, which stays in context after leaving team scope.
 */
export default function useIsOutsideTeamScope() {
  const { teamKey } = useTeamPath();
  const { pathname } = useLocation();

  return (
    !teamKey && TEAMLESS_ROUTES.some((route) => pathname.startsWith(route))
  );
}
